<template>
  <div class="chart7">
    <div id="Chart7" style="width: 100%; height: 250px"></div>
    <div class="chart7_table">
      <table border="1" cellspacing="0">
        <tr>
          <th v-for="(item, index) in chart7_data_table" :key="'1' + index">
            {{ item.data1 }}
          </th>
        </tr>
        <tr class="tr2">
          <td v-for="(item, index) in chart7_data_table" :key="'2' + index">
            {{ item.data2 }} <i v-if="item.data2">%</i>
          </td>
        </tr>
        <tr>
          <td v-for="(item, index) in chart7_data_table" :key="'3' + index">
            {{ item.data3 }} <i v-if="item.data3">%</i>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    chart7_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_y:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_y2:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_table:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    myEcharts7() {
      var myChart7 = this.$echarts.init(document.getElementById("Chart7"));
      //配置图表
      var option7 = {
        grid: {
          containLabel: true,
          left: 0,
          right: 15,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart7_data_x,
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            // show: false,
            lineStyle: {
              color: "#f3f3f3",
            },
          },
          axisLabel: {
            formatter: function (value) {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return ``;
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "白色家电",
            type: "line",
            color: "#fcad2a",
            data: this.chart7_data_y,
            symbol:'circle',
          },
          {
            name: "格力电器",
            type: "line",
            color: "#539cff",
            data: this.chart7_data_y2,
            symbol:'circle',
            label: {
              formatter: "{c}%",
              show: true,
              color: "#539cff",
              position: "top",
            },
          },
        ],
      };
      myChart7.setOption(option7);
    },
  },
  mounted() {
    // this.myEcharts7();
  },
};
</script>

<style scoped>
i{
  font-style: normal;
}
.chart7_table {
  margin-top: 10px;
}
table {
  border-color: #e9ebf3;
  border-collapse: collapse;
}
th,
td {
  width: 150px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}
th {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
td {
  font-size: 14px;
  color: #fcad2a;
}
.tr2 td{
  color: #539cff;
}
</style>